import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const PrivacySettings = () => {
  const [settings, setSettings] = useState({
    dataCollection: true,
    consultationRecording: false,
    marketingCommunication: false,
    thirdPartySharing: false,
    analyticsTracking: true
  });

  const handleSettingChange = (key, value) => {
    setSettings(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const privacyOptions = [
    {
      key: 'dataCollection',
      title: 'Datenerfassung für Beratung',
      description: 'Erfassung grundlegender Informationen für die Rechtsberatung (erforderlich)',
      required: true
    },
    {
      key: 'consultationRecording',
      title: 'Beratungsaufzeichnung',
      description: 'Aufzeichnung von Beratungsgesprächen für Qualitätssicherung',
      required: false
    },
    {
      key: 'marketingCommunication',
      title: 'Marketing-Kommunikation',
      description: 'Erhalt von Informationen über neue Services und Angebote',
      required: false
    },
    {
      key: 'thirdPartySharing',
      title: 'Datenweitergabe an Dritte',
      description: 'Weitergabe anonymisierter Daten für Forschungszwecke',
      required: false
    },
    {
      key: 'analyticsTracking',
      title: 'Website-Analytics',
      description: 'Verwendung von Cookies für Website-Verbesserungen',
      required: false
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-professional border border-slate-200 p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
            <Icon name="Settings" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <h2 className="text-xl font-semibold text-text-primary">Datenschutz-Einstellungen</h2>
            <p className="text-sm text-text-secondary">Verwalten Sie Ihre Datenschutzpräferenzen</p>
          </div>
        </div>
        <Button variant="outline" size="sm" iconName="Download">
          Einstellungen exportieren
        </Button>
      </div>
      <div className="space-y-4">
        {privacyOptions?.map((option) => (
          <div key={option?.key} className="flex items-start space-x-3 p-4 bg-muted/50 rounded-lg">
            <Checkbox
              checked={settings?.[option?.key]}
              onChange={(e) => handleSettingChange(option?.key, e?.target?.checked)}
              disabled={option?.required}
              className="mt-1"
            />
            <div className="flex-1">
              <div className="flex items-center space-x-2">
                <h3 className="font-medium text-text-primary">{option?.title}</h3>
                {option?.required && (
                  <span className="px-2 py-1 text-xs bg-primary/10 text-primary rounded-full">
                    Erforderlich
                  </span>
                )}
              </div>
              <p className="text-sm text-text-secondary mt-1">{option?.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-between mt-6 pt-4 border-t border-slate-200">
        <p className="text-sm text-text-secondary">
          Letzte Aktualisierung: {new Date()?.toLocaleDateString('de-DE')}
        </p>
        <div className="flex space-x-3">
          <Button variant="outline" size="sm">
            Zurücksetzen
          </Button>
          <Button variant="default" size="sm" iconName="Save">
            Einstellungen speichern
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PrivacySettings;